/**
 * @generated SignedSource<<34a73b48c1fa900229cfa64e18f94958>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BasisEnum = "CASH" | "NORMALIZED" | "%future added value";
export type generateExportButtonMutation$variables = {
  basis?: BasisEnum | null | undefined;
  from?: string | null | undefined;
  kind: string;
  perspectiveId?: string | null | undefined;
};
export type generateExportButtonMutation$data = {
  readonly exportCreate: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly export: {
      readonly id: string;
      readonly status: string;
    } | null | undefined;
  } | null | undefined;
};
export type generateExportButtonMutation = {
  response: generateExportButtonMutation$data;
  variables: generateExportButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "basis"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "kind"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perspectiveId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "basis",
    "variableName": "basis"
  },
  {
    "kind": "Variable",
    "name": "from",
    "variableName": "from"
  },
  {
    "kind": "Variable",
    "name": "kind",
    "variableName": "kind"
  },
  {
    "kind": "Variable",
    "name": "perspectiveId",
    "variableName": "perspectiveId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Export",
  "kind": "LinkedField",
  "name": "export",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "generateExportButtonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "ExportCreateMutationPayload",
        "kind": "LinkedField",
        "name": "exportCreate",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "generateExportButtonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "ExportCreateMutationPayload",
        "kind": "LinkedField",
        "name": "exportCreate",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "104d809d06436cc916acee89b0d4329f",
    "id": null,
    "metadata": {},
    "name": "generateExportButtonMutation",
    "operationKind": "mutation",
    "text": "mutation generateExportButtonMutation(\n  $kind: String!\n  $perspectiveId: ID\n  $basis: BasisEnum\n  $from: String\n) {\n  exportCreate(kind: $kind, perspectiveId: $perspectiveId, basis: $basis, from: $from) {\n    export {\n      id\n      status\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "61662e9eebaeee0556ac22cd85b3c684";

export default node;
